import * as ReturnCodesConstants from '../../../../../constants/ReturnCodesConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      flag:false,
      productDetailsList: [],
      id:'',
      centerHeight: document.documentElement.clientHeight - 135 +'px',
      montyTotal:0,
      returnData:{}
    }
  },
  computed: {
  },
  methods: {
    ...mapActions('productOrderModule', ['submitOrder']),
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    getProductDetailsInfo () {
      this.getProductDetails({'id': this.id})
    },
    async purchase () {
      let listId = []
      this.productDetailsList.filter(item => {
        listId.push({
          commodityId:item.id,
          commodityQty: item.commodityQty
        })
      })
      let res = await this.submitOrder(listId)
      if (res.code === ReturnCodesConstants.SUCCESS_CODE) {
        this.$router.push({
          path: RoutePathConstants.PAYMENT_DETAILS,
          query: {
            data: JSON.stringify(this.productDetailsList),
            returnData: JSON.stringify(res.data)
          }
        })
      } else {
        this.$message.error(`添加失败！`)
      }
    },
    handleChange (val) {
      this.montyTotal = 0
      this.productDetailsList.filter(item => {
        if (item.paymentMethod === 1000) {
          this.montyTotal += item.commodityStoredValueCard * 1 * item.commodityQty
        } else if (item.paymentMethod === 2000) {
          this.montyTotal += item.commodityPoints * 1 * item.commodityQty
        } else if (item.paymentMethod === 3000) {
          this.montyTotal += item.commodityCash * 1 * item.commodityQty
        }
      })
      if (this.productDetailsList[0].paymentMethod === 1000) {
        this.montyTotal = this.montyTotal + '储值金'
      } else if (this.productDetailsList[0].paymentMethod === 2000) {
        this.montyTotal = this.montyTotal + '积分'
      } else if (this.productDetailsList[0].paymentMethod === 3000) {
        this.montyTotal = this.montyTotal + '元'
      }
    }
  },
  mounted () {
    this.productDetailsList = JSON.parse(this.$route.query.data).filter(item => {
      if (!item.payNum) {
        item.payNum = 1
      }
      if (!item.commodityQty) {
        item.commodityQty = 1
      }
      return item
    })
    this.handleChange()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-order/views/product-order.js